import React, {} from 'react';
import { connect } from "react-redux";
import { SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 } from "../../../../../constants";
import { setSQFTActiveButton, setSQFTMenuOpened } from "../../../../../../../actions/sqftMenuFunctions";
import LookFilters from "../../../../../../look/lookNavigation/lookFilters/lookFilters";

const SqftNavFiltersMenu = (props) => {
  const { activeLevel3Button, featurePicker } = props;
  const expanded = activeLevel3Button === SIDEBAR_NAVIGATION_BUTTONS_LEVEL3.filters

  const className = "content " + (expanded ? " expanded" : "")
    + (featurePicker.isOpen ? " content--right side-level3right" : " content--left side-level3");

  return (
    <div className={className}>
      <div className="side-level3__inner height-100">
        <LookFilters isRelatedItemsFilters={ false } shouldCloseLevel3Sidebar={ true }/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const { activeLevel3Button } = store.sqftMenuState;
  const { featurePicker } = store.sqftMenuState;
  return {
    activeLevel3Button,
    featurePicker,
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavFiltersMenu);
